var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('common.errors.404'),expression:"'common.errors.404'"}]})])])}
var staticRenderFns = []

export { render, staticRenderFns }